import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getMainConfig, getBannerLinks } from './admin/apiCalls';
import { store } from '../Store';
import LoadingSpinner from './LoadingSpinner';

export default function Banner() {

  const WEB_FOLDER = window.REACT_APP_WEB_FOLDER || "";
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;
  const [title, setTitle] = useState('');
  const [bannerLinks, setBannerLinks] = useState([]);
  const { state, dispatch } = useContext(store);
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  // const currentLocation = useLocation();

  const styleTheme = {
    'subsubtitle': `${configData?.theme && configData.theme}-subsubtitle`
  }

  useEffect(() => {
    getMainConfig(setTitle);
    getBannerLinks(setBannerLinks);
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  const staticImages = {
      logo: `${WEB_FOLDER}/uploads/logo.jpg`,//`${WEB_FOLDER}/img/logo.jpg`,
      logoCepal: `${WEB_FOLDER}/img/logo-cepal.png`,
      logoRedatam: `${WEB_FOLDER}/img/logo-redatam.jpg`,
      logoGIZ: `${WEB_FOLDER}/img/logo-giz.png`,
      rightBanner: `${WEB_FOLDER}/img/banner-derecha.png`,
      leftBanner: `${WEB_FOLDER}/img/banner-izquierda.png`
  };

  const linksBanner = {
    urlCepal: 'https://cepal.org/',
    urlRedatam: 'https://cepal.org/es/subtemas/redatam',
    urlGIZ: 'https://www.giz.de/en/',
  }

  /*
  let bannerContent = (
    <>
    <div className="odisea-page-related-links">
      <ul>
        { bannerLinks.map ((item) => <li><a key = {item.url} href={item.url}> {item.title} </a></li>)}
      </ul>
    </div>
    <div className="odisea-page-header odisea-page-header-flex">
      <div className="odisea-page-header-logo1">
        <Link to="/" className='site-logo' rel='home' title='Portal Odisea'>
          <img src={staticImages.leftBanner} alt="Inicio" />
        </ Link>
      </div>
      <div className="odisea-page-header-title">
        {console.log(title.title)}
        <h1> {title?.pageTitle && title.pageTitle } </h1>
        <h2> {title?.pageSubtitle && title.pageSubtitle } </h2>
        <h3 className={styleTheme.subsubtitle} > {title?.pageSubSubtitle && title.pageSubSubtitle } </h3>
      </div>
      <div className="odisea-page-header-logo2">
        <img src={staticImages.rightBanner} alt="Inicio" />
      </div>
    </div>

    </>
  )
  */

  const bannerContent = (
    <>
    <div className="odisea-page-related-links">
      <ul>
        { bannerLinks.map ((item) => <li><a key = {item.url} href={item.url}> {item.title} </a></li>)}
      </ul>
    </div>
    <div className="odisea-page-header odisea-page-header-flex waves-odisea-page-header-flex">
      <div className="odisea-page-header-logo2">
        <a href={configData?.logoLink ? configData.logoLink : "#"}>
          <img src={staticImages.logo} className="odisea-page-header-logo-ine" alt="" />
        </a>
        <a href={linksBanner.urlCepal}>
          <img src={ staticImages.logoCepal } alt="" style={{height:"90px", 'margin-right': '20px'}} />
        </a>
        <a href={linksBanner.urlRedatam}>
          <img src={ staticImages.logoRedatam } alt="" style={{height:"100px"}} />
        </a>
        <a href={linksBanner.urlGIZ}>
          <img src={ staticImages.logoGIZ } alt="" style={{height:"100px"}} />
        </a>
      </div>
      <div className="waves-odisea-page-header-title">
        <div className="odisea-page-header-logo1">
          <Link to="/" className='site-logo' rel='home' title='Portal Odisea'>
            <img src={staticImages.leftBanner} alt="" />
          </ Link>
        </div>
        <div className="odisea-page-header-title">
          <h1> {title?.pageTitle && title.pageTitle } </h1>
          <h2> {title?.pageSubtitle && title.pageSubtitle } </h2>
          <h3 className={styleTheme.subsubtitle} > {title?.pageSubSubtitle && title.pageSubSubtitle } </h3>
        </div>
      </div>
    </div>

    </>
  )


  return (
    <>
      {title !== '' ? bannerContent : <LoadingSpinner />}
    </>
  )

}
